module.exports = __webpack_public_path__ + "static/media/prajwal_bhosale.aadba4b6.jpg";